<div class="bg-white border m-2 py-3 px-3 shadow-sm">
  <h5>Spare</h5>
  @if (isAssignedDevice() | async) {
  <div class="mb-2">
    <span class="text-danger">Warning:</span> Marking this device as spare will remove the ability to control the room
    with the app and will show the setup app. When doing this the device should not be in a room anymore.
  </div>
  }
  <era-device-link-selector [selection]="selection$ | async"
                            [isSpare]="true"
                            [isHousekeeping]="false"
                            (selectionChange)="updateSelection($event)">
  </era-device-link-selector>
  <button type="submit"
          class="btn btn-success me-2"
          (click)="spare()">Spare</button>
  <a type="cancel"
     class="btn btn-outline-primary"
     [routerLink]="['../']">Cancel</a>
</div>